<div class="range-input-filter-container" [class.isHotels]="isHotels">
  <app-box-filter [individualFilter]="individualFilter" [index]="index" [label]="label" [show]="isOpenBox" (toggleShow)="toggleOpenBox()">
    <div class="range-filter">
      <div class="bar-cont">
        <app-ds-slider
          [ranges]="[min, max]"
          [picked]="pickedValues"
          (changeSlider)="setValues($event)"
          (slideSlider)="setLabels($event)">
        </app-ds-slider>
      </div>
      <div class="cont-values">
        <p>{{ pickedMinValue | rangeType: rangeType }}</p>
        <p>{{ pickedMaxValue | rangeType: rangeType }}</p>
      </div>
    </div>
  </app-box-filter>
</div>